// FileUploadTable.js

import React, { useState } from "react";
import { GridColDef, GridRowClassNameParams } from "@mui/x-data-grid";
import {
  Paper,
  Alert,
  AlertTitle,
  Chip,
  Button,
  Snackbar,
  Box,
} from "@mui/material";
import Papa from "papaparse";
import { MuiFileInput } from "mui-file-input";
import ButtonCustom from "../../../components/ButtonCustom";
import DataGridCustom from "../../../components/DataGridCustom";
import { Quiz } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import useUploadFaq from "../../../hooks/reversal/useUploadFaq";
import useGetReversalInfos from "../../../hooks/reversal/useGetReversalInfos";
import CustomCircularProgress from "../../../components/CustomCircularProgress";
import Grid from "@mui/material/Unstable_Grid2";

const FileUploadTable = () => {
  const navigate = useNavigate();
  const [fileData, setFileData] = useState<any>([]);
  const [file, setFile] = useState(null);
  const [isloading, setIsLoading] = useState(false);
  const profileUser = localStorage.getItem("profile");
  const { uploadFaq } = useUploadFaq();  
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openError, setOpenError] = useState(false);
  const { data: dataFaq } = useGetReversalInfos("CÉLO/15");
  const [invalidFAQRows, setInvalidFAQRows] = useState<number[]>([]);
  const loginUser = localStorage.getItem("Login");

  type CSVRow = { [key: string]: string };

  const readCSVFile = (
    file: File,
    callback: (data: CSVRow[]) => void
  ): void => {
    const reader = new FileReader();
    reader.onload = (event: ProgressEvent<FileReader>) => {
      if (event.target && event.target.result) {
        const csvData: string = event.target.result as string;
        Papa.parse<CSVRow>(csvData, {
          complete: (results) => {
            callback(results.data);
            const invalidFAQRows = results.data.reduce(
              (acc: number[], row: any, index: number) => {
                const faqCheck = dataFaq.some(
                  (faq) => faq.label === row.ID_FAQ
                );                
                const estornoCheck =
                  row["ESTORNADO"] === "Sim" ||
                  row["ESTORNADO"] === "Não" ||
                  row["ESTORNADO"] === "Pendente";
                if (!faqCheck || !estornoCheck) {
                  acc.push(index + 1);
                }
                return acc;
              },
              []
            );
            if (invalidFAQRows.length > 0) {
              setInvalidFAQRows(invalidFAQRows);
            }
          },
          header: true,
          skipEmptyLines: true,
          encoding: "ISO-8859-1",
        });
      }
    };
    reader.readAsText(file, "ISO-8859-1");
  };

  const handleFileChange = (event: any): void => {
    const selectedFile: File | undefined = event;
    setFile(event);
    if (selectedFile) {
      readCSVFile(selectedFile, (data: CSVRow[]) => {
        // Aqui você pode fazer o que quiser com os dados do CSV, como atualizar o estado do componente
        const newData = data.map((item, index) => {
          if (typeof item === "object" && item !== null) {
            return { ...item, id: index };
          }
          return item;
        });
        setFileData(newData);
      });
    } else {
      setFileData([]);
      setInvalidFAQRows([]);
    }
  };

  const sendForms = async () => {
    setIsLoading(true);
    try {
      const filteredData = fileData.filter((pedido: any) => {
        const faqCheck = dataFaq.some((faq) => faq.label === pedido.ID_FAQ);
        
        const estornoCheck =
          pedido["ESTORNADO"] === "Sim" ||
          pedido["ESTORNADO"] === "Não" ||
          pedido["ESTORNADO"] === "Pendente";
        return faqCheck && estornoCheck;
      });
      const dataToSend = {
        perfil: profileUser,
        items: filteredData.map((resp: any) => ({
          idCase: resp["ID_FORMULARIO"],
          estornado: resp["ESTORNADO"],       
          login:loginUser,
          faq: dataFaq.find((faq) => faq.label === resp["ID_FAQ"])?.idBRAN,
          financeiro: resp["COD_AUT"] ?? "",
        })),
      };
      uploadFaq(dataToSend).then((res: any) => {
        if (res?.status === 200) {
          setOpenSuccess(true);
          setIsLoading(false);
          navigate(-1);
        } else {
          setOpenError(true);
        }
      });
    } catch {
    } finally {
      setIsLoading(false);
    }
  };
  const columns: GridColDef[] = [
    {
      field: "ID_FORMULARIO",
      headerName: "ID_FORMULARIO",
      width: 200,
    },
    {
      field: "NOME COMPLETO",
      headerName: "NOME COMPLETO",
      width: 300,
    },
    {
      field: "TELEFONE",
      headerName: "TELEFONE",
      width: 300,
    },
    {
      field: "EMAIL",
      headerName: "EMAIL",
      width: 300,
    },
    {
      field: "MOTIVO DA SOLICITAÇÃO",
      headerName: "MOTIVO DA SOLICITAÇÃO",
      width: 200,
    },
    {
      field: "DATA DO PEDIDO",
      headerName: "DATA DO PEDIDO",
      width: 150,
    },
    {
      field: "NÚMERO DO PEDIDO",
      headerName: "NÚMERO DO PEDIDO",
      width: 150,
    },
    {
      field: "LOJA",
      headerName: "LOJA",
      width: 150,
    },
    {
      field: "FRANQUEADA?",
      headerName: "FRANQUEADA?",
      width: 150,
    },
    {
      field: "QUAL PROBLEMA DO PEDIDO?",
      headerName: "QUAL PROBLEMA DO PEDIDO?",
      width: 200,
    },

    {
      field: "VALOR ESTORNADO",
      headerName: "VALOR ESTORNADO",
      width: 300,
    },
    {
      field: "QUAL ITEM FALTOU OU FOI ENVIADO INCORRETAMENTE?",
      headerName: "QUAL ITEM FALTOU OU FOI ENVIADO INCORRETAMENTE?",
      width: 300,
    },
    {
      field: "PEDIDO REALIZADO",
      headerName: "PEDIDO REALIZADO",
      width: 300,
    },
    {
      field: "ANEXO DA NOTA FISCAL",
      headerName: "ANEXO DA NOTA FISCAL",
      width: 300,
    },
    {
      field: "ANEXO DO PEDIDO",
      headerName: "ANEXO DO PEDIDO",
      width: 300,
    },
    {
      field: "ESTORNADO",
      headerName: "ESTORNADO",
      width: 150,
    },
    {
      field: "COD_AUT",
      headerName: "COD_AUT",
      width: 150,
    },
    {
      field: "ID_FAQ",
      headerName: "ID_FAQ",
      width: 150,
    },
    {
      field: "DATA DO FORMULÁRIO",
      headerName: "DATA DO FORMULÁRIO",
      width: 150,
    },
    {
      field: "EMAIL_ENVIADO",
      headerName: "EMAIL_ENVIADO",
      width: 150,
    },
    {
      field: "DATA DO EMAIL",
      headerName: "DATA DO EMAIL",
      width: 150,
    },
  ];

  const getRowClassName = (params: GridRowClassNameParams) => {
    const faqCheck = dataFaq.some((faq) => faq.label === params.row.ID_FAQ);    
    const estornoCheck =
      params.row["ESTORNADO"] === "Sim" ||
      params.row["ESTORNADO"] === "Não" ||
      params.row["ESTORNADO"] === "Pendente";
    const isInvalidFAQ = faqCheck && estornoCheck;
    return isInvalidFAQ ? "" : "invalid-faq-row";
  };
  return (
    <React.Fragment>
      {isloading && (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          height="100vh"
        >
          <CustomCircularProgress />
        </Box>
      )}
      {!isloading && (
        <React.Fragment>
          <Snackbar
            autoHideDuration={6000}
            anchorOrigin={{ horizontal: "right", vertical: "top" }}
            open={openSuccess}
            onClose={() => setOpenSuccess(false)}
            key={"success"}
          >
            <Alert
              onClose={() => setOpenSuccess(false)}
              severity="success"
              sx={{ width: "100%" }}
            >
              Importe realizado com sucesso!
            </Alert>
          </Snackbar>
          <Snackbar
            autoHideDuration={6000}
            anchorOrigin={{ horizontal: "right", vertical: "top" }}
            open={openError}
            onClose={() => setOpenError(false)}
            key={"error"}
          >
            <Alert
              onClose={() => setOpenError(false)}
              severity="error"
              sx={{ width: "100%" }}
            >
              Erro ao importar!
            </Alert>
          </Snackbar>
          <Paper elevation={3} style={{ padding: "20px", marginTop: "20px" }}>
            <Grid container spacing={2}>
              <Grid xs={12} md={12} lg={12} xl={12}>
                <Button
                  style={{ display: "flex", alignItems: "center" }}
                  onClick={() => navigate(-1)}
                >
                  Voltar
                </Button>
                <Chip
                  style={{ marginLeft: "20px", marginTop: "20px" }}
                  icon={<Quiz color="warning" />}
                  label="Upload e envio de FAQ"
                />
              </Grid>
              <Grid xs={10} md={10} lg={10} xl={10}>
                <MuiFileInput
                  value={file}
                  onChange={handleFileChange}
                  style={{
                    marginBottom: "20px",
                    marginLeft: "20px",
                    marginTop: "20px",
                  }}
                />
              </Grid>
              <Grid xs={2} md={2} lg={2} xl={2}>
                <ButtonCustom event={sendForms} text="Enviar" />
              </Grid>
            </Grid>
            {fileData.length > 0 && (
              <React.Fragment>
                {invalidFAQRows.length > 0 && (
                  <Alert
                    severity="error"
                    style={{ marginBottom: "10px", marginTop: "10px" }}
                  >
                    <AlertTitle>
                      Linha(s) com FAQ inválido. Caso o arquivo seja enviado,
                      essas linhas serão desconsideradas. Exporte o arquivo
                      novamente e faça a atualização
                    </AlertTitle>
                  </Alert>
                )}
                <DataGridCustom
                  rows={fileData}
                  columns={columns}
                  getRowId={(row: any) => row.id}
                  getRowClassName={getRowClassName}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 50,
                      },
                    },
                  }}
                />
              </React.Fragment>
            )}
          </Paper>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default FileUploadTable;
